import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogClose, MatDialogActions } from '@angular/material/dialog';
import { Organization } from '../../organization-models';
import { EnvironmentLoaderService } from 'src/app/shared/services/environment-loader.service';
import { SnackbarService, FeedbackFailComponent } from 'ok-angular-shared/components';
import { BehaviorSubject } from 'rxjs';
import { ImitationSessionService } from 'src/app/shared/services/imitation-session.service';
import moment from 'moment';
import { END } from '@angular/cdk/keycodes';
import { ImitationSession } from './imitation-session-model';
import { AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'adm-imitate-organization-modal',
  templateUrl: './imitate-organization-modal.component.html',
  styleUrls: ['./imitate-organization-modal.component.scss'],
  imports: [FeedbackFailComponent, AsyncPipe, MatDialogTitle, MatDialogContent, MatDialogClose, MatButton, MatIcon, MatDialogActions],
})
export class ImitateOrganizationModalComponent implements OnInit {
  data = inject<{
    organization;
  }>(MAT_DIALOG_DATA);
  private imitationSessionService = inject(ImitationSessionService);
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private snackbarService = inject(SnackbarService);

  public organization: Organization;
  public loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public imitationSuccess = true;
  public imitationSession: ImitationSession;
  public publicPortalName = this.environmentLoaderService.config.publicPortalName;
  public publicPortalBaseUrl = this.environmentLoaderService.config.publicPortalBaseUrl;
  public moment = moment;
  async ngOnInit(): Promise<void> {
    this.moment.locale('da');
    // this.loading$ = new BehaviorSubject(true);
    this.organization = this.data.organization;
  }

  public goToPublicPortal() {
    this.imitationSessionService
      .startImitationSession(this.organization.id)
      .subscribe({
        next: resp => {
          this.imitationSession = resp;
          window.open(this.publicPortalBaseUrl, 'imitationWindow_' + this.organization.id, 'height=768,width=1280');
        },
        error: err => {
          this.imitationSuccess = false;
          console.error(err);
          this.snackbarService.error('Der skete en fejl. Imitering er muligvis mislykkedes.');
        },
      })
      .add(() => {
        this.loading$ = new BehaviorSubject(false);
      });
  }

  public async endImitationSession() {
    this.imitationSessionService.endImitationSession().subscribe({
      next: () => {
        this.snackbarService.success('Imitering blev succesfuldt afsluttet.');
      },
      error: err => {
        console.error(err);
        this.snackbarService.error('Der skete en fejl. Imitering er muligvis mislykkedes.');
      },
    });
  }

  protected readonly END = END;
}
